import type {DresonResolvedData, FacetValueTagsLoadedData} from "./types/global";
import {trackingStore} from "./store/TrackingStore";
import {tlSearchBoxActionCharacter} from "./tracking/labels/SearchBoxAction";
import {searchfieldStore, value} from "./store/SearchfieldStore";
import {encodedHistory, isEmpty, submitHistory} from "./store/HistoryStore";
import {SQRL_EVENT} from "./events/sqrlEvents";
import {navSlider} from "./components/suggestLayer/navSlider/NavSlider";
import {sqrlRequest} from "./util/SqrlRequest";
import {get} from "svelte/store";
import {sqrlConsentBanner} from "./util/SqrlConsentBanner";
import type {EventMergeContext} from "@otto-ec/tracking-bct";

export class SearchHandler {

  /**
 *
 *
 *
 *
 */
  fetchSearchTerm() {
    const searchterm = document
      .querySelector("#reptile-searchterm")
      ?.getAttribute("data-searchterm");
    if (searchterm) {
      trackingStore.$sendTrackingLabelOnFocus = false;
      tlSearchBoxActionCharacter.setIsTrackable(false);
      searchfieldStore.$value = searchterm;
    }
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
  enableEventFilterListener() {
    window.o_global.events().on("ftfind.dresonRule.resolved", ({rule, redirect}: DresonResolvedData) =>
      submitHistory.updateTarget(rule, redirect),
    );
    window.o_global.events().on("heureka.facetValueTags.loaded", ({rule, tags}: FacetValueTagsLoadedData) =>
      submitHistory.updateTags(rule, tags),
    );
  }

  initNavSlider() {
    window.o_global.events().on(SQRL_EVENT.SEARCH_FOCUS, (mergeContext: EventMergeContext) => {
      navSlider.onMergeEventContext(mergeContext);
    });
  }
  async init() {
    this.fetchSearchTerm();
    await sqrlConsentBanner.update().finally(() =>  {
      sqrlConsentBanner.listenOnConsentChange();
      submitHistory.reInitialize();
      sqrlRequest.fetch(
          get(value),
          get(value).length,
          get(isEmpty) ? undefined : encodedHistory(),
          true,
      );
    })
    this.enableEventFilterListener();
    this.initNavSlider();
  }
}

export const searchHandler = new SearchHandler();
